import { ok } from '@xlearn/common';
import { complex, complexAttrib, rwAttrib, SchemaEngine, woAttrib, collectionAttrib, roAttrib } from '../schema-engine';
import { getCompletionStatus, setCompletionStatus } from './completion-status.actions';
import { getSuccessStatus, setSuccessStatus } from './success-status.actions';
import { getLocation, setLocation } from './location.actions';
import { getSuspendData, setSuspendData } from './suspend-data.actions';
import { Model } from './model';
import { setSessionTime } from './session-time.actions';
import { interaction } from './interaction-schema';
import { defaultInteraction } from './interaction';
import { score } from './score-schema';
import { objective } from './objective-schema';
import { defaultObjective } from './objective';
import { setExit } from './exit.actions';
import { getStudentInfo } from './student-info.actions'

export class Scorm2004Schema {

  private schemaEngine: SchemaEngine;

  constructor() {
    this.schemaEngine = new SchemaEngine(schema());
  }

  public getModel(element: string, model: Model) {
    return this.schemaEngine.getValue(element, model);
  }

  public setModel(element: string, value: string, model: Model) {
    return this.schemaEngine.setValue(element, value, model);
  }
}

function schema() {
  return complex({
    cmi: complexAttrib(cmi())
  });
}

function cmi() {
  return complex({
    completion_status: rwAttrib(getCompletionStatus, setCompletionStatus, 'model', 'completionStatus'),
    success_status: rwAttrib(getSuccessStatus, setSuccessStatus, 'model', 'successStatus'),
    location: rwAttrib(getLocation, setLocation, 'model', 'location'),
    suspend_data: rwAttrib(getSuspendData, setSuspendData, 'model', 'suspendData'),
    session_time: woAttrib(setSessionTime, 'model', 'sessionTime'),
    score: complexAttrib(score(), 'model', 'score'),
    interactions: collectionAttrib(interaction(), defaultInteraction, 'model', 'interactions'),
    objectives: collectionAttrib(objective(), defaultObjective, 'model', 'objectives'),
    exit: woAttrib(setExit, 'model', 'exit'),
    learner_id: roAttrib(getStudentInfo, 'model', 'studentInfo', 'id'),
    learner_name: roAttrib(getStudentInfo, 'model', 'studentInfo', 'fullName')
  });
}
